
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Wie sieht es mit Milch aus? Soll man sie trinken?</b><br />
Ja, ein sehr umstrittenes Thema. Ich halte Milch für ein Wachstumsgetränk. Muttermilch ist super für Babys, um sie schnell wachsen zu lassen. Aber Kuhmilch? Und dann für Erwachsene? Bei uns wächst ja nicht mehr so viel, ausser Krebs. Milch wird zum Beispiel in Zusammenhang mit einem erhöhten Prostatakrebsrisiko gebracht. Man sieht, dass Menschen, die keine Milch vertragen, systematisch weniger von bestimmten Krebsformen betroffen sind. Klar, auch hier macht die Dosis das Gift. Früher habe ich immer noch einen Schuss Milch in den Kaffee getan, und das ist bestimmt okay. Inzwischen aber habe ich entdeckt, dass mir Hafermilch viel besser schmeckt. Ich halte sie auch für eindeutig gesünder!
    <b>Was empfehlen Sie, wenn jemand auf gesunde Weise ein paar Kilo abnehmen möchte?</b><br />
Viele pflanzliche Lebensmittel essen, vor allem mit reichlich Protein in diesem Fall, insbesondere Broccoli, Spinat und Spargeln. Dann natürlich Hülsenfrüchte wie Linsen, Bohnen und Kichererbsen (Hummus). Sie enthalten nicht nur viel sättigendes Protein, sondern auch sättigende Ballaststoffe. Dazu vielleicht regelmässig Olivenöl und ein kleines Schälchen Joghurt mit Beeren wie Blaubeeren. Joghurt gehört manchen Studien zufolge zu den «Schlankmachern» Nummer eins! Nüsse sind auch gut, vermutlich weil sie ebenfalls sehr gut sättigen. Dann reichlich Omega-3-Quellen essen, in Form von Leinsamen, Chia-Samen, aber auch ab und zu ein Stückchen Lachs, Hering, Makrele oder Forelle. Zusätzlich noch Vollkornprodukte wie ein Vollkornbrot oder Haferflocken.
    <b>Als ziemlich neue, schlank machende Ernährungsform wird momentan Intervallfasten gepriesen. Man isst nur zu gewissen Zeiten, dazwischen wird pausiert. Was halten Sie davon?</b><br />
Die Nahrungsaufnahme zeitlich zu begrenzen, finde ich einen guten Ansatz. Diese Form von Intervallfasten lässt sich leicht durchhalten und ist eventuell auch hilfreich. Jedenfalls ist es einen Versuch wert.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;